import { css } from 'lit';

var css_248z = css`:host{--fileupload-left-icon-fill:green;--fileupload-remove-icon-fill:red;--fileupload-remove-icon-hover-fill:#c00}.fileupload-list-item span{cursor:pointer}.fileupload-list-item span:first-of-type svg{fill:var(--fileupload-left-icon-fill)}.fileupload-list-item span:last-of-type svg{fill:var(--fileupload-remove-icon-fill)}.fileupload-list-item span:last-of-type svg:hover{fill:var(--fileupload-remove-icon-hover-fill)}.file-upload__label{align-items:center;display:flex;gap:.5rem}`;

export { css_248z as default };
//# sourceMappingURL=sgds-file-upload2.js.map
